import styled from "styled-components"

export const MaintenanceWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
